import {LOADING_KEY_PREFIX} from '@Panels/ai-voice-panel/ai-voice-panel.types';
import {type AiPromptBox, AiPromptBoxSize} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {PromptBoxState} from '@Components/ai-prompt-box/ai-prompt-box.types';
import {isUserPremium} from '@Libraries/user.library';

export const getLoadingKeyForAiVoice = (panelId: string): string => {
  return `${LOADING_KEY_PREFIX}-${panelId}`;
};

export const getPromptBoxOptions = (): AiPromptBox => {
  return {
    placeholder: window.i18next.t('pmwjs_text_to_speech_input_placeholder'),
    showInitialAnimation: false,
    size: AiPromptBoxSize.SMALL_EXTENDED,
    creditsPill: {
      visible: !isUserPremium(),
      actionCost: 0,
      remainingCredits: 0,
      showPremiumIcon: !isUserPremium(),
    },
    promptBoxState: PromptBoxState.IDLE,
    prompt: '',
  };
};
